__turbopack_context__.v({
  "fullscreen": "Popup-module__1MQOlW__fullscreen",
  "in": "Popup-module__1MQOlW__in",
  "popup_close": "Popup-module__1MQOlW__popup_close",
  "popup_heading": "Popup-module__1MQOlW__popup_heading",
  "popup_heading_wrapper": "Popup-module__1MQOlW__popup_heading_wrapper",
  "popup_inner": "Popup-module__1MQOlW__popup_inner",
  "popup_overlay_close": "Popup-module__1MQOlW__popup_overlay_close",
  "popup_subheading": "Popup-module__1MQOlW__popup_subheading",
  "popup_wrapper": "Popup-module__1MQOlW__popup_wrapper",
});
